export default __webpack_public_path__ + "static/media/card-badges-sweepstakes.cfa8d16b.jpg";